import { render, staticRenderFns } from "./CovidCheckPoint.vue?vue&type=template&id=64607026&scoped=true&"
import script from "./CovidCheckPoint.vue?vue&type=script&lang=js&"
export * from "./CovidCheckPoint.vue?vue&type=script&lang=js&"
import style0 from "./CovidCheckPoint.vue?vue&type=style&index=0&id=64607026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64607026",
  null
  
)

export default component.exports